import { EventTracker, TrackedEvent } from './event-tracker'

export class MixpanelEventTracker implements EventTracker {
  constructor(private readonly mp: unknown) {}

  track(event: TrackedEvent, duration?: number): void {
    const { name, ...props } = event as Record<string, unknown>
    const trackProps = duration !== undefined ? { ...props, duration } : props
    try {
      ;(this.mp as { track: (name: string, props: Record<string, unknown>) => void }).track(name as string, trackProps)
    } catch (error) {
      // Silently fail if tracking fails
    }
  }

  identify(userId: string): Promise<void> {
    return new Promise(resolve => {
      ;(this.mp as { identify: (userId: string) => void }).identify(userId)
      resolve()
    })
  }

  reset(): void {
    ;(this.mp as { reset?: () => void }).reset?.()
  }
}
